import { LoginForm } from '../Components/LoginForm'

// Назву вкладки ставить сама LoginForm (вона ж показується замість розділів без доступу)
export default function LoginPage() {
    return <LoginForm />
}
